import React from 'react';
import { DollarSign, Users, Wrench, Activity } from 'lucide-react';

const stats = [
  { label: 'Ingresos del Mes', value: '$67,000', change: '+15.3%', icon: DollarSign, color: 'bg-green-100 text-green-600' },
  { label: 'Ocupación', value: '94%', change: '+2.1%', icon: Users, color: 'bg-blue-100 text-blue-600' },
  { label: 'Órdenes Pendientes', value: '12', change: '-3', icon: Wrench, color: 'bg-orange-100 text-orange-600' },
  { label: 'Visitas Hoy', value: '89', change: '+24%', icon: Activity, color: 'bg-purple-100 text-purple-600' },
];

export function StatsWidget() {
  return (
    <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 h-full">
      {stats.map((stat, index) => {
        const Icon = stat.icon;
        return (
          <div key={index} className="bg-gray-50 rounded-xl p-4 flex flex-col justify-between">
            <div className={`w-10 h-10 rounded-lg ${stat.color} flex items-center justify-center mb-3`}>
              <Icon className="w-5 h-5" />
            </div>
            <div>
              <p className="text-2xl font-bold text-gray-900">{stat.value}</p>
              <p className="text-sm text-gray-500 mb-1">{stat.label}</p>
              <span className={`text-xs font-medium ${
                stat.change.startsWith('+') ? 'text-green-600' : 
                stat.change.startsWith('-') ? 'text-red-600' : 'text-gray-600'
              }`}>
                {stat.change}
              </span>
            </div>
          </div>
        );
      })}
    </div>
  );
}

export default StatsWidget;
